import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import http from "../BaseUrl/baseurl";
import axios from "axios";
const token = localStorage.getItem("token");
const headers = {
    headers: {
        authorization: token
    }
};

export const getPropertyList = createAsyncThunk("getPropertyList", async () => {
    let response;
    try {
        response = await axios.get(`${baseUrl}/propertyverification`, headers);
    } catch (error) {
        return [];
    }

    return response.data;
});

export const getPropertybyId = createAsyncThunk("getPropertybyId", async id => {
    try {
        const response = await axios.get(
            `${baseUrl}/propertyverification/${id}`,
            {
                headers: {
                    authorization: token
                }
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
});

const PropertyVerification = createSlice({
    name: "propertyverification",

    initialState: {
        PropertyList: [],
        PropertyVerificationId: {},
        status: "",
        error: ""
    },

    extraReducers(builder) {
        // ... (other cases)

        // getPropertyVerificationPropertyIdList
        builder
            .addCase(getPropertyList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPropertyList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PropertyList = action.payload;
            })
            .addCase(getPropertyList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            //get property by id
            .addCase(getPropertybyId.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPropertybyId.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PropertyVerificationId = action.payload;
            })
            .addCase(getPropertybyId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export default PropertyVerification.reducer;
